/**
 * @param {RequestInit} [options]
 */
export function createFetchBasedFormFetcher(options) {
    return (formData, endpoint) => fetch(endpoint, Object.assign({ body: formData.toMultipartFormData(), method: 'post', 
        // IMPORTANT: Sitecore forms relies on cookies for some state management, so credentials must be included.
        credentials: 'include' }, options))
        .then((res) => res.json())
        .then((res) => res);
}
/**
 * @param {JssFormData} formData
 * @param {string} endpoint
 * @param {FormSubmitOptions} [options]
 */
export function submitForm(formData, endpoint, options) {
    options = options || {};
    if (!options.fetcher) {
        options.fetcher = createFetchBasedFormFetcher();
    }
    return options.fetcher(formData, endpoint);
}
